import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable, of, switchMap, tap } from 'rxjs';

import {
  MaintenanceBypassService,
  MaintenanceService,
} from '@customer-portal/core';
import { LoggingService } from '@customer-portal/core/app-insights';
import { AppPagesEnum } from '@customer-portal/shared/constants';

import { AppInitializerService } from '../services';

export const appInitializer = (): Observable<any> => {
  const appInitializerService = inject(AppInitializerService);
  const maintenanceService = inject(MaintenanceService);
  const maintenanceBypassService = inject(MaintenanceBypassService);
  const router = inject(Router);

  return from(maintenanceBypassService.checkBypassToken()).pipe(
    switchMap(() => maintenanceService.checkMaintenanceStatus()),
    switchMap((maintenanceConfig) => {
      const currentPath = window.location.pathname;
      const bypassed = maintenanceBypassService.isBypassed();

      if (maintenanceConfig?.active && !bypassed) {
        if (!currentPath.includes(AppPagesEnum.Maintenance)) {
          return appInitializerService.logoutIfAuthenticated().pipe(
            switchMap(() =>
              from(
                router.navigateByUrl(AppPagesEnum.Maintenance, {
                  replaceUrl: true,
                }),
              ),
            ),
          );
        }

        router.initialNavigation();

        return of(true);
      }

      if (!maintenanceConfig?.active) {
        maintenanceBypassService.clearBypass();

        if (currentPath.includes(AppPagesEnum.Maintenance)) {
          return from(router.navigateByUrl('/', { replaceUrl: true })).pipe(
            switchMap(() => appInitializerService.initializePermissions()),
          );
        }
      }

      return appInitializerService.initializePermissions().pipe(
        tap(() => {
          router.initialNavigation();
        }),
      );
    }),
  );
};

export function loggingInitializer(): Promise<void> {
  const loggingService = inject(LoggingService);

  return loggingService.init();
}
